import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import IframeComm from "react-iframe-comm";
import Select from "react-select";
import * as _ from "lodash";
import EditorMobi from "../../editor/editorMobi";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { ChromePicker } from 'react-color'
import localStore from 'src/utils/local-storage'
import Uploader from '../../util/uploader';
import CkService from "src/services/CkService";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify'
// import spellCheck from 'src/utils/spell-check';
// import SpellError from 'src/components/util/spell-error';
import TuNhayCamWarning from 'src/components/util/tu-nhay-cam-warning';
import { Alert } from "react-bootstrap";
import getPrType from "src/utils/prType";

class ContentMobiTab extends Component {
  constructor() {
    super();
    const _user = localStore.get('_user');
    this.state = {
      currentPost: null,
      error: true,
      editorType: [
        { type: "normal", label: "Bài viết thường", value: "normal" },
        { type: "special", label: "Bài đặc biệt", value: "special" },
        { type: "mini", label: "Bài viết mini", value: "mini" },
        (_user.can_create_video_post && { type: "video", label: "Bài viết video", value: "video" })        
      ],
      editorTypeSelected: {
        type: "normal",
        label: "Bài viết thường",
        value: "normal"
      },
      prType: [],
      prSelected: { type: "0", label: "Không phải PR", value: "0" },
      isPr: false,
      styleColorBackGround: '#fff',
      styleImageBackGround: '',
      crop_ver: {
        unit: 'px',
        width: 660,
        aspect: 1,
        x: 0,
        y: 0,
      },
      spellData: {}
    };

    this.colorPickerRef = React.createRef()
  }

  componentDidMount() {
    // console.log(1);
    document.addEventListener('click', this.handleClick)
  }

  componentWillUnmount() {
    // important
    // console.log(2);
    document.removeEventListener('click', this.handleClick)
  }

  handleClick = (event) => {
    const { target } = event
    if (!this.colorPickerRef.current.contains(target)) {
      // let { stylePicker } = this.state;
      this.setState({ stylePicker: false });
    }
  }

  UNSAFE_componentWillMount() {
    // console.log(3);
    const {
      post: { currentPost }
    } = this.props;
    let { editorType, editorTypeSelected, isPr, prType, prSelected } = this.state;
    const _user = localStore.get('_user');
    const isAdmin = _user.role.name == 'SuperAdmin';
    const disablePR = currentPost.publisher ? (isAdmin ? false : true) : false;

    prType = getPrType(disablePR);

    if (currentPost.editor_type) {
      editorTypeSelected = _.find(editorType, type => {
        return type.type == currentPost.editor_type;
      });
    } else {
      currentPost.editor_type = "normal";
      this.props.setCurrentPost(currentPost);
    }

    if (currentPost.pr_type) {
      prSelected = _.find(prType, type => {
        return type.value == currentPost.pr_type;
      });
    } else {
      currentPost.pr_type = "0";
      this.props.setCurrentPost(currentPost);
    }

    this.setState({
      currentPost, editorTypeSelected, pr_type: currentPost.pr_type, prSelected, prType, styleColorBackGround: currentPost.content_background
      , styleImageBackGround: currentPost.content_image
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log(4);
    const {
      post: nextPost,
      fields: nextFields,
      currenttab: nextTab
    } = nextProps;
    const { fields, post, typepage, currenttab: currentTab } = this.props;
    if (post.currentTabPost === 3 && nextPost.currentTabPost !== 3) {
      const { currentPost } = nextPost;
      // console.log(currentPost);
      this.props.setCurrentPost(currentPost);
      let { editorType, editorTypeSelected, isPr, prType, prSelected } = this.state;
      if (currentPost.editor_type) {
        editorTypeSelected = _.find(editorType, type => {
          return type.type == currentPost.editor_type;
        });
        // console.log(editorTypeSelected);
      } else {
        currentPost.editor_type = "normal";
        this.props.setCurrentPost(currentPost);
      }

      if (currentPost.pr_type) {
        prSelected = _.find(prType, type => {
          return type.value == currentPost.pr_type;
        });
      } else {
        currentPost.pr_type = "0";
        this.props.setCurrentPost(currentPost);
      }

      this.setState({editorTypeSelected});
    }

    this.setState({
      listTab: nextProps.listTab,
    });
  }

  getValueEditorType = value => {
    if (value.type !== this.state.editorTypeSelected.type) {
      this.confirmAction(value);
    }
  };

  getValuePRType = value => {
    let { prType, prSelected } = this.state;
    if (value) {
      prSelected = _.find(prType, type => {
        return type.value == value.value;
      });
      const { post: { currentPost } } = this.props;
      currentPost.pr_type = prSelected.value;
      // khi nào pr price chưa được set thì mới lấy giá default từ báo giá chèn vào ô prprice
      if(prSelected.value > 0 && prSelected.prprice && (!currentPost.prprice || currentPost.prprice == 0)){
        // get default prprice
        currentPost.prprice = prSelected.prprice;
      }
      // ngược lại nếu đã có prprice hiện popup thông báo user có muốn tự động thay đổi giá
      if(prSelected.value > 0 && prSelected.prprice && currentPost.prprice && prSelected.prprice != currentPost.prprice){
        this.confirmActionUpdatePRPrice(prSelected.prprice)
      }
      this.props.setCurrentPost(currentPost);

      this.setState({ prSelected });
    }

  };

  handleCreatePost(data) {
    // console.log(data);
    const {
      post: { currentPost }
    } = this.props;
    currentPost.content_m = data;
    this.props.setCurrentPost(currentPost);
  }

  changeStatusPR(check) {
    const {
      post: { currentPost }
    } = this.props;
    this.setState({ isPr: check }, () => {
      currentPost.is_pr = check;
      this.props.setCurrentPost(currentPost);
    });
    this.props.isPr(check);
  }

  confirmActionUpdatePRPrice(value) {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        },
        {
          label: "No",
          onClick: () => alert("Click No")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn đã thay đổi loại bài PR. Bạn có muốn tự động cập nhật giá?</h1>
          <div className="box">
            <div className="bg-d9534f" onClick={onClose}>
              Không, tôi sẽ tự thay đổi
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.updatePRPrice(value);
                onClose();
              }}
            >
              Có, cập nhật tự động
            </div>
          </div>
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => { },
      onClickOutside: () => { },
      onKeypressEscape: () => { }
    };

    confirmAlert(options);
  }
  updatePRPrice = value => {
    const { post: { currentPost } } = this.props;
    if(currentPost.prprice != value){
      currentPost.prprice = value;
      this.props.setCurrentPost(currentPost);
      this.props.onSelectPRType(this.state.prSelected.type, currentPost);
    }
  };

  confirmAction(value) {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        },
        {
          label: "No",
          onClick: () => alert("Click No")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn sắp chuyển qua layout soạn bài khác.</h1>
          <div className="box">
            <div className="bg-d9534f" onClick={onClose}>
              Không, cần xem lại
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.updateEditorType(value);
                onClose();
              }}
            >
              Có, tiếp tục
            </div>
          </div>
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => { },
      onClickOutside: () => { },
      onKeypressEscape: () => { }
    };

    confirmAlert(options);
  }

  updateEditorType = value => {
    let { editorType, editorTypeSelected } = this.state;
    if (value) {
      editorTypeSelected = _.find(editorType, type => {
        return type.type == value.value;
      });
      const {
        post: { currentPost }
      } = this.props;
      currentPost.editor_type = editorTypeSelected.value;
      // if(currentPost.editor_type == 'mini' || currentPost.editor_type == 'special'){
      //   this.setDefaultTag(currentPost.editor_type);
      // }
      
      this.props.setCurrentPost(currentPost);
      this.props.onSelectEditorType(editorTypeSelected);
      this.setState({ editorTypeSelected });
    }
  };

  //ticket 140:Tự động gắn tag cho bài special và mini special
  setDefaultTag(type){
    const { post: { currentPost }, config: { configuration } } = this.props;
    let tag_id = _.find(configuration, (conf) => conf.label == `${type}_tag_id`);  
    let filterTag = _.find(currentPost.tags, (tag) => {
      return tag.id == tag_id.value;
    });
    if(!filterTag){
      currentPost.tags = [...currentPost.tags, {_id: tag_id.value, value: tag_id.value, label: tag_id.label}];
      this.props.setCurrentPost(currentPost);
    }
  }

  changeBackground = value => {
    const { post: { currentPost } } = this.props;
    currentPost.content_background = value;
    this.props.setCurrentPost(currentPost);
  }
  changeImageBackground = value => {
    const { post: { currentPost } } = this.props;
    currentPost.content_image = value;
    this.setState({ styleImageBackGround: value }, () => {
      this.props.setCurrentPost(currentPost);
    })
  }


  handleColorChange = ({ hex }) => {
    this.setState({ styleColorBackGround: hex })
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.changeBackground(hex);
    }, 1000);
  }

  handleBackground = () => {
    let { stylePicker } = this.state
    this.setState({ stylePicker: !stylePicker });
  }

  handleImageCrop = data => {
    // console.log(data);
  }
  noneedcrop = data => {
    const { post: { currentPost } } = this.props
    currentPost.content_image = data.url;
    this.setState({ styleImageBackGround: data.url }, () => {
      this.props.setCurrentPost(currentPost);
      toast.success("Đã chọn ảnh nền");
    })
  }

  copyContentPC = () => {
    let currentPost = this.props.content;

    if (currentPost.content_m) {
      const options = {
        title: "Title",
        message: "Message",
        buttons: [
          {
            label: "Yes",
            onClick: () => alert("Click Yes")
          },
          {
            label: "No",
            onClick: () => alert("Click No")
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ onClose }) => (
          <div className="custom-ui-alert">
            <h1>Nội dung Mobile hiện tại sẽ bị mất. Bạn chắc chắn muốn copy nội dung từ phiên bản Desktop?</h1>
            <div className="box">
              <div className="bg-d9534f" onClick={onClose}>
                Không, cần xem lại
            </div>
              <div
                className="bg-c7c6c5"
                onClick={() => {
                  currentPost.content_m = currentPost.content;
                  this.props.setCurrentPost(currentPost);
                  toast.success("Đã copy nội dung");
                  onClose();
                }}
              >
                Có, tiếp tục
            </div>
            </div>
          </div>
        ),
        closeOnEscape: true,
        closeOnClickOutside: true,
        willUnmount: () => { },
        onClickOutside: () => { },
        onKeypressEscape: () => { }
      };

      confirmAlert(options);
    } else {
      currentPost.content_m = currentPost.content;
      this.props.setCurrentPost(currentPost);
      toast.success("Đã copy nội dung");
    }
  }

  render() {
    const currentPost = this.props.content;
    let { layoutName, checkClass, channels } = this.props;
    let { listTab } = this.state;

    const type = currentPost.editor_type;
    let typeEditor = this.state.currentPost.editor_type;
    return (
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 " + checkClass}>
            <h4 className="card-title">Nội dung bài viết</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}

        <div className="card-body col-12">
          <div className="row mb-3">
            <div ref={this.colorPickerRef} className={`col-xl-2 col-lg-6 col-6 col-sm-4 mb-3 align-self-center ml-auto justify-content-between ${( typeEditor == 'normal' || typeEditor == 'video' ) ? 'd-none' : 'd-flex' }`}>
              <button
                onClick={this.handleBackground}
                className={"btn bg-maroon btn-block " + (this.state.styleColorBackGround !== '#fff' ? 'mr-2' : '')}
              >Chọn màu nền</button>
              {
                this.state.styleColorBackGround !== '#fff' &&
                <button
                  onClick={() => this.handleColorChange({ hex: '#fff' })}
                  className="btn btn-inline-block"
                  style={{ backgroundColor: `${this.state.styleColorBackGround}` }}
                ><i className="fas fa-times"></i></button>
              }
              <div className={"position-absolute " + (this.state.stylePicker ? '' : 'd-none')}
                style={{ zIndex: 9999, left: '0px' }}>
                <ChromePicker onChangeComplete={this.handleColorChange} color={this.state.styleColorBackGround} />
              </div>

            </div>

            <div className={`col-xl-2 col-lg-6 col-6 col-sm-4 mb-3 align-self-center ml-auto justify-content-between ${( typeEditor == 'normal' || typeEditor == 'video' ) ? 'd-none' : 'd-flex' }`}>
              <Uploader channels={channels} channel={currentPost.channel} noneedcrop={this.noneedcrop} no_crop={true} tmp_id={currentPost.tmp_id || currentPost.id} url={currentPost.content_image} crop={this.state.crop_ver} type="content_image" handleImageCrop={this.handleImageCrop} styleImageBackGround={this.state.styleImageBackGround} />

              {this.state.styleImageBackGround &&
                <button
                  onClick={(e) => {
                    this.changeImageBackground('')
                  }}
                  className="btn btn-inline-block"
                  style={{ backgroundImage: `url('${this.state.styleImageBackGround}')` }}
                ><i className="fas fa-times"></i></button>
              }
            </div>

            <div className={`col-xl-2 col-lg-6 col-6 col-sm-4 mb-3 ml-auto`}>
              <button className="btn btn-block bg-primary" onClick={this.copyContentPC}>Copy nội dung PC</button>
            </div>
          </div>
          <div className="row">
            {/* <SpellError 
              spellData={this.state.spellData} 
              className="col-12"
            />    */}
                                  
            <div className={"col-12 overflow-hidden " + currentPost.editor_type + " editor-" + currentPost.editor_type}>
              <EditorMobi
                channel={currentPost.channel}
                channels={channels}
                post={currentPost}
                editorTypeSelected={this.state.editorTypeSelected}
                styleColorBackGround={this.state.styleColorBackGround}
                styleImageBackGround={this.state.styleImageBackGround}
                onChange={content => {
                  this.onContentChange(content);
                }}
                onBlur={content => {
                  //check Nội dung
                  this.props.checkRequireData(currentPost, 13);
                  //check Nội dung External link
                  this.props.checkRequireData(currentPost, 10);
                  //check Nội dung Internal link
                  this.props.checkRequireData(currentPost, 15);
                  // check External Image
                  this.props.checkRequireData(currentPost, 11);
                  // spellCheck(content).then(data => {
                  //   this.setState({
                  //     spellData: data
                  //   })
                  // })                  
                }}
              />
              {/* <div className={`text-info`}>
                <Alert variant="info">
                  <p className="mb-0">@ dùng để chèn Bài Podcast, Video</p>
                  <p className="mb-0"># dùng để chèn link Xem thêm</p>
                </Alert>
              </div> */}
            </div>
            <TuNhayCamWarning
              listTab={listTab}
              className="col-12"
            />  
          </div>
        </div>
      </div>
    );
  }
  onContentChange(content) {
    let currentPost = this.props.content;
    currentPost.content_m = content ? content : ' ';
    this.props.setCurrentPost(currentPost);
    this.props.handleCheckExternalIMGError();
  }
}

export default connect(
  store => {
    return {
      post: store.post,
      config: store.config
    };
  },
  dispatch => {
    return {
      setCurrentPost: value => {
        dispatch(postActions.setCurrentPost(value));
      }
    };
  }
)(ContentMobiTab);
